function Animate(related,x,y,text) {

    this.name = 'animate';
    this.related=related;
    this.x=x;
    this.y=y;
    this.text=text;
}

export {Animate};
